import React, { useEffect } from 'react'
import './Style.css'
import Logo from '../Images/logo.png'
import { FaPhone ,FaEnvelope ,FaLocationDot  } from "react-icons/fa6";

const Footer = () => {
 
  return (
    <>
    <div className='footer'>
      <div className='row'>
        <div className='col-md-9'>
          <div className='logoF'><img src={Logo} alt=""/></div>
          <p>AMFI REGISTERED MUTUAL FUND DISTRIBUTOR</p>
          
          <p>ARN REGISTRATION NUMBER : ARN-345634</p>
          <p>ARN VALIDITY PERIOD : 14 NOV 2025 TO 13 NOV 2028</p>
        </div>
       <div className='col-md-3'>
        
        <div className='FiconDiv'> <a href="mailto:support@plan2prosper.in">
    <FaEnvelope className='Ficon'/> support@plan2prosper.in
  </a></div>
        <div className='FiconDiv'> <a href="tel:+919920421701">
    <FaPhone className='Ficon'/> +91 99204 21701
  </a></div>
        <div className='FiconDiv'><FaLocationDot  className='Ficon'/> Mumbai, India</div>
       </div>
      </div>
      <hr/>
      <div className='copyRight'>© 2025 Plan2Prosper. All rights reserved.</div>
        
    </div>
    </>
  )
}

export default Footer